import React, { useEffect, useState } from 'react';
import {
  Box,
} from '@mui/joy';
import ButtonAttribute from '../../Components/ButtonAttribute';
import { faDownload, faCheck, faCloudArrowUp, faFileExport, faFileImport, faPen, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGridTable from '../../Components/TableData';
import {
  createTheme, Divider, Grid, Grid2, ThemeProvider, Typography, Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer
} from '@mui/material';
import BasicModal from '../../Components/BasicModel';
import axios from 'axios';
import { API } from '../../API/api';
import TextInputMui from '../../Components/TextInputMui';
import AlertBar from '../../Components/AlertBar';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import CustomizedProgressBars from '../../Components/CustomizedProgressBars';
import AutocompleteComboBox from '../../Components/AutocompleteComboBox';
import { useNavigate } from 'react-router-dom';
import TarificationService from '../../API/TarificationsService';

const theme = createTheme({
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h4: {
      fontWeight: 700,
      letterSpacing: '-0.025em'
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.025em'
    },
    body1: {
      fontWeight: 500
    }
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#3b82f6',
      light: '#8b9eff',
      dark: '#2563eb'
    },
    secondary: {
      main: '#8b5cf6',
      light: '#a78bfa',
      dark: '#7c3aed'
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff'
    },
    text: {
      primary: '#1f2937',
      secondary: '#6b7280'
    }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
          }
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }
      }
    }
  }
});



export default function Tarification() {
  const [ImportData, setImportData] = useState();
  const [isLoading, setIsLoading] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tarifications, setTarifications] = useState([]);
  const [openAjouterTarification, setOpenAjouterTarification] = React.useState(false);
  const [rowsSelected, setRowsSelected] = React.useState({});
  const handleOpen = () => {
    setOpenAjouterTarification(true);
  };
  const handleClose = () => setOpenAjouterTarification(false);
  const [Permissions, setPermissions] = useState([]);
  const [role, setRole] = useState([]);
  const Navigate = useNavigate();
  {/* modifier Tarification */ }
  const [openModifierTarification, setOpenModifierTarification] = React.useState(false);
  const handleOpenModifier = () => {
    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
    if (selectedRows.length > 0) {
      setOpenModifierTarification(true);
      setRowsSelected(selectedRows);
      setModifierTarification(selectedRows[0]);
    }
    else {
      setAlertOpenSelectedModifier(true);
    }
  }
  const handleCloseModifier = () => {
    setOpenModifierTarification(false);
  }

  const [alertOpenSelectedModifier, setAlertOpenSelectedModifier] = useState(false);
  const handleAlertCloseSelectedModifier = () => { setAlertOpenSelectedModifier(false); }
  const [alertOpenNotModiferRow, setAlertOpenNotModiferRow] = useState(false);
  const handleAlertCloseNotModiferRow = () => { setAlertOpenNotModiferRow(false); }
  const handleAlertOpenNotModiferRow = () => { setAlertOpenNotModiferRow(true); }
  const [alertOpenUpdatedTarification, setAlertOpenUpdatedTarification] = useState(false);
  const handleAlertCloseUpdatedTarification = () => { setAlertOpenUpdatedTarification(false); }
  const handleAlertOpenUpdatedTarification = () => { setAlertOpenUpdatedTarification(true); }

  const handleOpenModifierOneTarification = async () => {
    if (rowsSelected[0].ID_Client === modifierTarification.ID_Client &&
      rowsSelected[0].depart === modifierTarification.depart &&
      rowsSelected[0].destination === modifierTarification.destination &&
      rowsSelected[0].taxi === modifierTarification.taxi &&
      rowsSelected[0].T3_5 === modifierTarification.T3_5 &&
      rowsSelected[0].T7 === modifierTarification.T7 &&
      rowsSelected[0].T14 === modifierTarification.T14 &&
      rowsSelected[0].T18 === modifierTarification.T18 &&
      rowsSelected[0].semi_remorque === modifierTarification.semi_remorque &&
      rowsSelected[0].Tracteur === modifierTarification.Tracteur

    ) {

      handleAlertOpenNotModiferRow();

    }
    else {

      if (
        !modifierTarification.ID_Client ||
        !modifierTarification.depart ||
        !modifierTarification.destination
      ) {
        setErrors({
          error: true,
          message: " Tous les champs sont obligatoires "
        });

      }
      else {
        try {
          const storedAuthState = sessionStorage.getItem('authLocalstorage');
          const parsedAuthState = JSON.parse(storedAuthState);
          const parentId = modifierTarification.ID_depart;
          const childId = modifierTarification.id;

          // 1. Update the parent tarification
          await axios.put(`${API}/tarifications/${parentId}`, {
            ID_Client: modifierTarification.ID_Client,
            depart: modifierTarification.depart
          }, {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` }
          });

          // 2. Update the child tarification
          await axios.put(`${API}/tarifications/${childId}`, {
            ID_Client: modifierTarification.ID_Client,
            adresse: modifierTarification.adresse,
            destination: modifierTarification.destination,
            taxi: modifierTarification.taxi,
            T3_5: modifierTarification.T3_5,
            T7: modifierTarification.T7,
            T14: modifierTarification.T14,
            T18: modifierTarification.T18,
            Tracteur: modifierTarification.Tracteur,
            semi_remorque: modifierTarification.semi_remorque,
            ID_depart: parentId
          }, {
            headers: { Authorization: `Bearer ${parsedAuthState.token}` }
          });

          handleAlertOpenUpdatedTarification();
          handleCloseModifier();
          fetchTarifications(parsedAuthState.token);

        } catch (error) {
          if (error.response) {
            console.error('Erreur serveur :', error.response.data.error);
          } else if (error.request) {
            console.error('Erreur de requête :', error.request);
          } else {
            console.error('Erreur interne :', error.message);
          }

          setErrors({ error: true, message: "Erreur lors de la modification" });
        }
      }

    }

  }
  {/* end modifier Tarification */ }

  const [errors, setErrors] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);

  const handleAlertClose = () => { setAlertOpen(false); };
  const [newTarification, setNewTarification] = useState({
    ID_Client: '',
    depart: '',
    destination: '',
    taxi: '',
    T3_5: '',
    T7: '',
    T14: '',
    T18: '',
    Tracteur: '',
    semi_remorque: '',
  });

  const [modifierTarification, setModifierTarification] = useState({
    id: '',
    ID_Client: '',
    depart: '',
    destination: '',
    taxi: '',
    T3_5: '',
    T7: '',
    T14: '',
    T18: '',
    Tracteur: '',
    semi_remorque: '',
    ID_depart: '',
  });

  const [tarificationsClient, setTarificationsClient] = useState([]);
  {/* Delete Tarification */ }
  const [alertOpenDeletedTarification, setAlertOpenDeletedTarification] = useState(false);
  const handleAlertCloseDeletedTarification = () => { setAlertOpenDeletedTarification(false); }
  const handleAlertOpenDeletedTarification = () => { setAlertOpenDeletedTarification(true); }
  const [alertOpenMultiDeletedTarification, setAlertMultiOpenDeletedTarification] = useState(false);
  const handleAlertMultiCloseDeletedTarification = () => { setAlertMultiOpenDeletedTarification(false); }
  const handleAlertMultiOpenDeletedTarification = () => { setAlertMultiOpenDeletedTarification(true); }
  const [openDeleteTarification, setOpenDeleteTarification] = useState(false);
  const [alertOpenPasswordNotValid, setAlertOpenPasswordNotValid] = useState(false);
  const handleAlertClosePasswordNotValid = () => { setAlertOpenPasswordNotValid(false); }
  const handleAlertOpenPasswordNotValid = () => { setAlertOpenPasswordNotValid(true); }
  const handleOpenDeleteTarification = () => {
    const selectedRows = JSON.parse(localStorage.getItem('selectedRows'), null, 2);
    if (selectedRows.length > 0) {
      setOpenDeleteTarification(true);
      setRowsSelected(selectedRows);
      setModifierTarification(selectedRows[0]);

    }
    else {
      setAlertOpenSelectedModifier(true);
    }

  }
  const handleCloseDeleteTarification = () => { setOpenDeleteTarification(false); }
  const handleDeleteTarification = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const token = parsedAuthState.token;

    const childId = modifierTarification.id;
    const parentId = modifierTarification.ID_depart;

    try {
      // 1. Delete child first
      await axios.delete(`${API}/tarifications/${childId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // 2. Delete parent after child
      if (parentId) {
        await axios.delete(`${API}/tarifications/${parentId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      // UI updates
      handleCloseDeleteTarification();
      setAlertOpenDeletedTarification(true);
      fetchTarifications(token);

    } catch (error) {
      if (error.response) {
        console.error('Erreur serveur :', error.response.data.error);
      } else if (error.request) {
        console.error('Erreur de requête :', error.request);
      } else {
        console.error('Erreur interne :', error.message);
      }
      setErrors({ error: true, message: "Erreur lors de la suppression" });
    }
  };

  const handleDeleteMultiTarifications = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const token = parsedAuthState.token;

    const parentIdsToDelete = new Set();

    try {
      // 1. Delete all child rows
      const childDeletePromises = rowsSelected.map((row) => {
        if (row.ID_depart) {
          parentIdsToDelete.add(row.ID_depart); // Collect parent ID
        }

        return axios.delete(`${API}/tarifications/${row.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      });

      await Promise.all(childDeletePromises);

      // 2. Delete unique parent rows
      const parentDeletePromises = Array.from(parentIdsToDelete).map((parentId) => {
        return axios.delete(`${API}/tarifications/${parentId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
      });

      await Promise.all(parentDeletePromises);

      // 3. Final UI actions
      handleCloseDeleteTarification();
      handleAlertMultiOpenDeletedTarification();
      fetchTarifications(token);

    } catch (error) {
      if (error.response) {
        console.error("Error Response:", error.response.data.error);
      } else if (error.request) {
        console.error("Error Request:", error.request);
      } else {
        console.error("Error Message:", error.message);
      }
      setErrors({ error: true, message: "Erreur lors de la suppression multiple" });
    }
  };


  const handleVerificationPassword = () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const email = parsedAuthState.user.email;
    const password = ConfrimedPassword.password;

    axios
      .post(`${API}/verify-password`, { email, password })
      .then((response) => {
        if (response.data.success) {
          if (rowsSelected.length === 1) {
            handleDeleteTarification();
          } else {
            handleDeleteMultiTarifications();
          }
          handleCloseConfirmationPassword();
          fetchTarifications(parsedAuthState.token);
        } else {
          // Handle unexpected responses where success is false
          setConfirmedPassword({
            errors: true,
          });
          console.error("Password verification failed:", response.data);
          handleAlertOpenPasswordNotValid();
        }
      })
      .catch((error) => {
        // Handle errors from the server or network issues
        if (error.response) {
          // Server responded with a status other than 2xx
          console.error("Error response:", error.response.data);
          setConfirmedPassword({
            errors: true,
          });
          handleAlertOpenPasswordNotValid();
        } else if (error.request) {
          // Request was made but no response received
          console.error("No response received:", error.request);
        } else {
          // Something else happened
          console.error("Error setting up request:", error.message);
        }
      });

  }


  {/* End Delete Tarification */ }

  {/* Begin Extration Tarification */ }
  const [openExtrationTarification, setOpenExtrationTarification] = useState(false);
  const handleCloseExtrationTarification = () => { setOpenExtrationTarification(false); }
  const handleOpenExtrationTarification = () => { setOpenExtrationTarification(true); }
  const [alertOpenNotSelectedLineExtration, setAlertOpenNotSelectedLineExtration] = useState(false);
  const handleAlertOpenNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(true) };
  const handleAlertCloseNotSelectedLineExtration = () => { setAlertOpenNotSelectedLineExtration(false) };

  const handleExtrationAllTarification = () => {
    if (!tarifications || tarifications.length === 0) return;

    // Prepare data using your columns definition
    const formattedData = tarifications.map((row) => {
      const newRow = {};

      columns.forEach((col) => {
        let value = row[col.accessorKey];

        // If column has custom Cell rendering (like ID_Client)
        if (col.accessorKey === "ID_Client") {
          const client = clients.find(
            (c) => c.ID_Client == row.ID_Client
          );
          value = client ? client.Nom : "";
        }

        newRow[col.header] = value ?? "";
      });

      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tarifications");

    XLSX.writeFile(workbook, "Tarifications.xlsx");
  };
  const handleExtrationSelectionsTarifications = () => {
    const selectedRows = JSON.parse(localStorage.getItem("selectedRows"));

    if (!selectedRows || selectedRows.length === 0) {
      handleAlertOpenNotSelectedLineExtration();
      return;
    }

    const formattedData = selectedRows.map((row) => {
      const newRow = {};

      columns.forEach((col) => {
        let value = row[col.accessorKey];

        if (col.accessorKey === "ID_Client") {
          const client = clients.find(
            (c) => c.ID_Client == row.ID_Client
          );
          value = client ? client.Nom : "";
        }

        newRow[col.header] = value ?? "";
      });

      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tarifications");

    XLSX.writeFile(workbook, "Tarifications_Selected.xlsx");
  };
  {/* End Extration Tarification */ }

  {/* Begin importation Tarification */ }
  const [openImportationTarification, setOpenImportationTarification] = useState(false);
  const handleCloseImportationTarification = () => { setOpenImportationTarification(false); }
  const handleOpenImportationTarification = () => { setOpenImportationTarification(true); }
  const [alertOpenImport, setAlertOpenImport] = useState(false);
  const handleAlertOpenImport = () => { setAlertOpenImport(true); }
  const handleCloseAlertImport = () => { setAlertOpenImport(false); }
  const [alertErrorImport, setAlertErrorImport] = useState(false);
  const handleOpenErrorAlertImport = () => { setAlertErrorImport(true); }
  const handleCloseErrorAlertImport = () => { setAlertErrorImport(false); }
  // Function to handle file download
  const handleDownload = () => {
    const filePath = `/ImportTarifications.xlsx`; // Adjust the path and filename as needed
    const link = document.createElement('a');
    link.href = filePath;
    link.download = 'ImportTarifications.xlsx'; // Name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  const triggerFileInput = () => {
    document.getElementById("file-upload").click();
  };

  // Handle file import and parse the Excel file
  const handleFileImport = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const token = parsedAuthState.token;

    reader.onload = async (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const totalRows = jsonData.length;
      let processedRows = 0;
      let successCount = 0;
      let errorCount = 0;
      let failedRows = []; // 🆕 Pour lister les erreurs
      setIsLoading(0);

      const uploadPromises = jsonData.map(async (row, index) => {
        try {
          const { ID_Client, depart, destination } = row;

          // Vérification de l'existence
          const response = await axios.get(`${API}/tarification/sreachTraficationByClient/${ID_Client}/${depart}`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const TarifExist = response.data.data.find(tarif =>
            tarif.ID_Client == ID_Client &&
            tarif.depart == depart &&
            tarif.destination == destination
          );

          if (TarifExist) {
            errorCount += 1;
            failedRows.push({
              index: index + 2, // ligne Excel (+2 pour header + index 0)
              message: "Tarification déjà existante pour ce client avec cette destination.",
            });
            return;
          }

          let parentId;

          if (response.data.exist) {
            // Parent existe
            parentId = response.data.data[0].id;
          } else {
            // Créer le parent
            const parentResponse = await axios.post(`${API}/tarifications`, {
              ID_Client: ID_Client,
              depart: depart
            }, {
              headers: { Authorization: `Bearer ${token}` },
            });
            parentId = parentResponse.data.data.id;
          }

          // Créer la ligne enfant
          await axios.post(`${API}/tarifications`, {
            ID_Client: ID_Client,
            destination: destination,
            adresse: row["adresse"] || '',
            taxi: row["taxi"],
            T3_5: row["T3_5"],
            T7: row["T7"],
            T14: row["T14"],
            T18: row["T18"],
            Tracteur: row["Tracteur"],
            semi_remorque: row["semi_remorque"],
            ID_depart: parentId
          }, {
            headers: { Authorization: `Bearer ${token}` },
          });

          successCount += 1;

        } catch (error) {
          errorCount += 1;
          failedRows.push({
            index: index + 2,
            message: error?.response?.data?.message || error.message || "Erreur inconnue",
          });
          console.error(`Erreur ligne ${index + 2}`, error);
        } finally {
          processedRows += 1;
          setIsLoading((processedRows / totalRows) * 100);
        }
      });

      Promise.all(uploadPromises)
        .then(() => {
          if (errorCount === 0) {
            handleAlertOpenImport();
            handleCloseImportationTarification();
          } else {
            handleOpenErrorAlertImport();
            console.table(failedRows);
            alert(`⚠️ Import terminé avec ${errorCount} erreur(s).\n\n${failedRows.map(r => `Ligne ${r.index} : ${r.message}`).join('\n')}`);
          }

          setIsLoading(0);
          fetchTarifications(token);
        })
        .catch((finalError) => {
          console.error("Erreur globale lors de l'import :", finalError);
          handleOpenErrorAlertImport();
          setIsLoading(0);
        });
    };

    reader.readAsBinaryString(file);
  };


  {/* end importation Tarification */ }

  {/* Begin Confirm password for delete Tarification */ }

  const [openConfirmationPassword, setOpenConfirmationPassword] = useState(false);
  const handleCloseConfirmationPassword = () => { setOpenConfirmationPassword(false); }
  const handleOpenConfirmationPassword = () => { setOpenConfirmationPassword(true); }
  const [ConfrimedPassword, setConfirmedPassword] = useState({
    password: "",
    errors: "",
  });
  const [alertOpenConfirmDeleteTarification, setAlertOpenConfirmDeleteTarification] = useState(false);
  const handleAlertOpenConfirmDeleteTarification = () => { setAlertOpenConfirmDeleteTarification(true); }
  const handleCloseAlertConfirmDeleteTarification = () => { setAlertOpenConfirmDeleteTarification(false); }

  {/* End Confirm password for delete Tarification */ }

  const MenuButton = () => {
    return (
      <Box sx={{
        backgroundColor: '#ffffff',
        border: '1px solid #e5e7eb4b',
        borderRadius: '32px',
        padding: { xs: '20px', md: '30px' },
        marginBottom: '20px',
        boxShadow: "0 4px 6px rgba(99, 102, 241, 0.2)",
      }}>
        {/* Header Section */}
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px',
          paddingBottom: '16px',
          borderBottom: '1px solid #f3f4f6'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Box sx={{
              width: '40px',
              height: '40px',
              borderRadius: '6px',
              backgroundColor: '#3b82f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <FontAwesomeIcon icon={faDownload} style={{ color: 'white', fontSize: '16px' }} />
            </Box>
            <Typography variant="h4" sx={{
              fontWeight: 600,
              color: '#1f2937',
              fontSize: { xs: '1.25rem', md: '1.5rem' },
              letterSpacing: '-0.025em'
            }}>
              Gestion des Tarifications
            </Typography>
          </Box>

          <Typography variant="body2" sx={{
            color: '#6b7280',
            fontSize: '14px',
            fontWeight: 500,
            backgroundColor: '#f9fafb',
            padding: '6px 12px',
            borderRadius: '6px',
            border: '1px solid #e5e7eb'
          }} >
            {tarifications.length} Tarifications
          </Typography>
        </Box>

        {/* Action Buttons Section */}
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          marginTop: '30px',
          alignItems: 'center',
          justifyContent: { xs: 'center', md: 'space-between' }
        }}>
          {/* Primary Actions */}
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {isAllowedAjouterTarification == 1 && (
              <ButtonAttribute
                Label="Ajouter"
                action={handleOpen}
                Bgcolor="#3b82f6"
                color="white"
                bgColorHover="#2563eb"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faPlus} style={{ fontSize: '14px' }} />}
                hidden={true}

              />
            )}
            {isAllowedModifierTarification == 1 && (
              <ButtonAttribute
                Label="Modifier"
                action={handleOpenModifier}
                Bgcolor="#f59e0b"
                color="white"
                bgColorHover="#d97706"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faPen} style={{ fontSize: '14px' }} />}
                hidden={true}

              />
            )}
            {isAllowedSupprimerTarification == 1 && (
              <ButtonAttribute
                Label="Supprimer"
                action={handleOpenDeleteTarification}
                Bgcolor="#ef4444"
                color="white"
                bgColorHover="#dc2626"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faTrash} style={{ fontSize: '14px' }} />}
                hidden={true}

              />
            )}
          </Box>

          {/* Secondary Actions */}
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            {isAllowedExporterTarification == 1 && (
              <ButtonAttribute
                Label="Exporter"
                action={handleOpenExtrationTarification}
                Bgcolor="#8b5cf6"
                color="white"
                bgColorHover="#7c3aed"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faFileExport} style={{ fontSize: '14px' }} />}
                hidden={true}

              />
            )}
            {isAllowedImporterTarification == 1 && (
              <ButtonAttribute
                Label="Importer"
                action={handleOpenImportationTarification}
                Bgcolor="#10b981"
                color="white"
                bgColorHover="#059669"
                type="button"
                height="45px"
                width="150px"
                startIcon={<FontAwesomeIcon color="white" icon={faFileImport} style={{ fontSize: '14px' }} />}
                hidden={true}

              />
            )}
          </Box>
        </Box>
      </Box>
    );
  };


  const columns = [
    {
      accessorKey: 'id', // Unique identifier
      header: 'ID',
      size: 100,
    },
    {
      accessorKey: 'ID_Client',
      header: 'ID Client',
      size: 200,
      Cell: ({ cell }) => {
        const idClient = cell.getValue();
        const client = clients.find(client => client.ID_Client == idClient);
        return client ? client.Nom : '';
      }
    },
    {
      accessorKey: 'depart',
      header: 'Départ',
      size: 300,
    },
    {
      accessorKey: 'destination',
      header: 'Destination',
      size: 300,
    },
    {
      accessorKey: 'taxi',
      header: 'Taxi',
      size: 150,
    },
    {
      accessorKey: 'T3_5',
      header: 'T3.5',
      size: 150,
    },
    {
      accessorKey: 'T7',
      header: 'T7',
      size: 150,
    },
    {
      accessorKey: 'T14',
      header: 'T14',
      size: 150,
    },
    {
      accessorKey: 'T18',
      header: 'T18',
      size: 150,
    },
    {
      accessorKey: 'Tracteur',
      header: 'Tracteur',
      size: 150,
    },
    {
      accessorKey: 'semi_remorque',
      header: 'Semi Remorque',
      size: 200,
    },

  ];


  // Function to get the 'allowed' value for a specific action
  const getPermission = (permissions, section, actionName) => {
    const sectionPermissions = permissions.find((perm) => perm.name === section);
    if (!sectionPermissions) return 0;

    const action = sectionPermissions.actions.find((act) => act.name === actionName);

    return action.allowed;
  };

  useEffect(() => {

    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);

    if (parsedAuthState?.token) {
      setPermissions(parsedAuthState.permissions);
      setRole(parsedAuthState.user.role.name);
      localStorage.removeItem('selectedRows');
    }
    else {
      Navigate("/");
    }

    if (parsedAuthState?.token) {
      fetchTarifications(parsedAuthState.token);
      fetchClients(parsedAuthState.token);
      const intervalId = setInterval(() => {
        setErrors({ error: false, message: '' });
      }, 10000);

      // Cleanup interval on component unmount
      return () => clearInterval(intervalId);
    } else {
      console.error('Token does not exist');
    }
  }, []);

  // Function to fetch tarifications
  const fetchTarifications = async (token) => {
    if (!token) return;

    try {
      const response = await TarificationService.getTarifications();
      setTarifications(response?.data || []);
    } catch (error) {
      console.error('Error fetching tarifications:', error);
      setTarifications([]); // always fallback to array
      setErrors({ error: true, message: 'Failed to fetch tarifications' });
    }
  };

  const [clients, setClients] = useState([]);

  const fetchClients = async (token) => {
    try {
      const response = await axios.get(`${API}/clients`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setClients(response.data.data);
    } catch (error) {
      console.error('Error fetching clients:', error);
      setErrors({ error: true, message: 'Failed to fetch clients' });
    }
  };

  const FilterTarifcations = (idClient) => {
    setTarificationsClient(prev =>
      tarifications.filter(tarif => tarif.ID_Client == idClient)
    );
  };

  const handleSelectionChangeID_Client = (keyField) => {
    setNewTarification((prev) => ({
      ...prev,
      ID_Client: keyField,

    }));

    FilterTarifcations(keyField);
  };



  const handleModifierSelectionChangeID_Client = (keyField) => {
    setModifierTarification((prev) => ({
      ...prev,
      ID_Client: keyField ?? "", // Use an empty string when keyField is null or undefined
    }));
  };

  {/* begin modal ajouter tarification  */ }

  const handleAjouterTarification = async () => {
    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState);
    const token = parsedAuthState.token;

    if (
      newTarification.ID_Client === '' ||
      newTarification.depart === '' ||
      newTarification.destination === ''
    ) {
      setErrors({ error: true, message: "Ce champ est obligatoire" });
      return;
    }

    try {
      const response = await axios.get(
        `${API}/tarification/sreachTraficationByClient/${newTarification.ID_Client}/${newTarification.depart}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const TarifExist = tarifications.find(tarif => tarif.ID_Client == newTarification.ID_Client && tarif.destination == newTarification.destination && tarif.depart == newTarification.depart);
      if (TarifExist) {
        setErrors({ error: true, message: "Cette tarification existe deja pour ce client " });
        return;
      }
      else {
        let parentId;
        if (response.data.exist) {

          parentId = response.data.data[0].id; // ⚠️ Bien utiliser [0] car `data` est un tableau
          // Créer la ligne enfant liée au parent

          await axios.post(
            `${API}/tarifications`,
            {
              ID_Client: newTarification.ID_Client,
              destination: newTarification.destination,
              taxi: newTarification.taxi,
              T3_5: newTarification.T3_5,
              T7: newTarification.T7,
              T14: newTarification.T14,
              T18: newTarification.T18,
              Tracteur: newTarification.Tracteur,
              semi_remorque: newTarification.semi_remorque,
              ID_depart: parentId
            },
            { headers: { Authorization: `Bearer ${token}` } }
          ).then((response) => {
            setAlertOpen(true);
            fetchTarifications(token);
            handleSelectionChangeID_Client(newTarification.ID_Client);
            const idClient = newTarification.ID_Client;
            setNewTarification({
              ID_Client: idClient,
              depart: '', destination: '', taxi: '', T3_5: '', T7: '', T14: '', T18: '', Tracteur: '', semi_remorque: ''
            });

          })

        } else {

          const parentRes = await axios.post(
            `${API}/tarifications`,
            {
              ID_Client: newTarification.ID_Client,
              depart: newTarification.depart
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          parentId = parentRes.data.data.id;
          // Créer la ligne enfant liée au parent
          await axios.post(
            `${API}/tarifications`,
            {
              ID_Client: newTarification.ID_Client,
              destination: newTarification.destination,
              taxi: newTarification.taxi,
              T3_5: newTarification.T3_5,
              T7: newTarification.T7,
              T14: newTarification.T14,
              T18: newTarification.T18,
              Tracteur: newTarification.Tracteur,
              semi_remorque: newTarification.semi_remorque,
              ID_depart: parentId
            },
            { headers: { Authorization: `Bearer ${token}` } }
          ).then((response) => {
            setAlertOpen(true);
            fetchTarifications(token);
            handleSelectionChangeID_Client(newTarification.ID_Client);
            const idClient = newTarification.ID_Client;
            setNewTarification({
              ID_Client: "",
              depart: '', destination: '', taxi: '', T3_5: '', T7: '', T14: '', T18: '', semi_remorque: ''
            });
            setInterval(() => {
              setNewTarification({
                ID_Client: idClient,
                depart: '', destination: '', taxi: '', T3_5: '', T7: '', T14: '', T18: '', semi_remorque: ''
              });
            }, 1000);

          })
        }
      }


    } catch (error) {
      console.error("Erreur lors de l'ajout :", error);
      setErrors({ error: true, message: "Une erreur est survenue." });
    }
  };


  const isAllowedAjouterTarification = getPermission(Permissions, 'tarifications', 'ajouter tarification');
  const isAllowedModifierTarification = getPermission(Permissions, 'tarifications', 'modifier tarification');
  const isAllowedSupprimerTarification = getPermission(Permissions, 'tarifications', 'supprimer tarification');
  const isAllowedExporterTarification = getPermission(Permissions, 'tarifications', 'exporter tarification');
  const isAllowedImporterTarification = getPermission(Permissions, 'tarifications', 'importer tarification');
  return (
    <ThemeProvider theme={theme}>
      {role === 'user' || role === 'admin' || role === 'super-admin' || role === 'user-facture' ? (
        <Box
          sx={{
            flexGrow: 1,
            backgroundColor: '#fcf9f8ff',
            padding: { xs: '16px', md: '20px' },
            minHeight: '116vh',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <MenuButton />
          <Box sx={{
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb',
            overflow: 'hidden'
          }}>
            <DataGridTable data={tarifications} columns={columns} />
          </Box>
        </Box>
      ) : null}


      {/* begin model ajouter tarification  */}
      <BasicModal

        widthSpecial={'60%'}
        open={openAjouterTarification}
        onClose={handleClose}
        ChildrenContent={
          <Box >
            <Typography variant='h4' sx={{
              fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' },
              mb: 2,
              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '20px'
            }}>
              Nouveau Tarification
            </Typography>
            <Grid container spacing={1} sx={{
              display: 'flex',
              justifyContent: 'center',
              borderRadius: '12px',
              color: '#1D3E62',
              gap: '5px'
            }} >

              <Grid sx={{ display: 'flex', justifyContent: 'center' }} item xs={12} sm={12} md={12} lg={10} xl={10}>

                <AutocompleteComboBox
                  required={true}
                  widthSpecific={'100%'}
                  Label={"Client"}
                  list={clients}
                  keyField={"ID_Client"} // Assurez-vous que ces champs correspondent à votre API
                  valueField={"Nom"} // Assurez-vous que ces champs correspondent à votre API
                  onChange={handleSelectionChangeID_Client}
                  value={newTarification.ID_Client}
                  error={errors.error && !newTarification.ID_Client}
                  helperText={
                    errors.error && !newTarification.ID_Client
                      ? "Client requis"
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                <TextInputMui
                  required={true}
                  label="Départ"
                  type="text"
                  value={newTarification.depart}
                  setValue={(e) => setNewTarification({ ...newTarification, depart: e })}

                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                <TextInputMui
                  required={true}
                  label="Destination"
                  type="text"
                  value={newTarification.destination}
                  setValue={(e) => setNewTarification({ ...newTarification, destination: e })}

                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                <TextInputMui

                  label="Taxi"
                  type="text"
                  value={newTarification.taxi}
                  setValue={(e) => setNewTarification({ ...newTarification, taxi: e })}

                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                <TextInputMui
                  label="T3.5"
                  type="text"
                  value={newTarification.T3_5}
                  setValue={(e) => setNewTarification({ ...newTarification, T3_5: e })}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                <TextInputMui

                  label="T7"
                  type="text"
                  value={newTarification.T7}
                  setValue={(e) => setNewTarification({ ...newTarification, T7: e })}

                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                <TextInputMui

                  label="T14"
                  type="text"
                  value={newTarification.T14}
                  setValue={(e) => setNewTarification({ ...newTarification, T14: e })}

                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                <TextInputMui

                  label="T18"
                  type="text"
                  value={newTarification.T18}
                  setValue={(e) => setNewTarification({ ...newTarification, T18: e })}

                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                <TextInputMui

                  label="Tracteur"
                  type="text"
                  value={newTarification.Tracteur}
                  setValue={(e) => setNewTarification({ ...newTarification, Tracteur: e })}

                />
              </Grid>

              <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                <TextInputMui

                  label="Semi remorque"
                  type="text"
                  value={newTarification.semi_remorque}
                  setValue={(e) => setNewTarification({ ...newTarification, semi_remorque: e })}

                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                {errors.error === true ? (
                  <Typography variant='subtitle1' component="p" sx={{
                    color: 'red',
                    textAlign: 'center',

                  }}>  {errors.message} </Typography>
                ) : null}
              </Grid>


              <Grid xs={12} sm={12} md={12} lg={12} xl={12}
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
              >
                <Box sx={{
                  width: { xs: '150px', sm: '200px', md: '300px', lg: '400px', xl: '500px' },
                  display: 'flex', justifyContent: 'center', alignItems: 'center'
                }}>
                  <ButtonAttribute
                    type="submit"
                    Label="Ajouter"
                    color={'white'}
                    Bgcolor='#28A745'
                    height={'60px'}
                    width={'100%'}
                    action={() => {
                      handleAjouterTarification();
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                {tarificationsClient.length > 0 && (
                  <Box sx={{ mt: 2, width: "100%" }}>

                    <TableContainer
                      sx={{
                        maxHeight: 90,
                        overflow: "auto",
                        border: "1px solid #ccc",
                        borderRadius: "8px"
                      }}
                    >
                      <Table stickyHeader size="small">

                        <TableHead>
                          <TableRow
                            sx={{
                              "& th": {
                                backgroundColor: "#f5f5f5",
                                fontWeight: "bold"
                              }
                            }}
                          >
                            <TableCell>Départ</TableCell>
                            <TableCell>Destination</TableCell>
                            <TableCell>Taxi</TableCell>
                            <TableCell>T3.5</TableCell>
                            <TableCell>T7</TableCell>
                            <TableCell>T14</TableCell>
                            <TableCell>T18</TableCell>
                            <TableCell>Semi remorque</TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {tarificationsClient.map((row, index) => (
                            <TableRow key={index} hover>
                              <TableCell>{row.depart}</TableCell>
                              <TableCell>{row.destination}</TableCell>
                              <TableCell>{row.taxi}</TableCell>
                              <TableCell>{row.T3_5}</TableCell>
                              <TableCell>{row.T7}</TableCell>
                              <TableCell>{row.T14}</TableCell>
                              <TableCell>{row.T18}</TableCell>
                              <TableCell>{row.semi_remorque}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>

                      </Table>
                    </TableContainer>

                  </Box>
                )}
              </Grid>

            </Grid>
          </Box>
        }
      />
      {/* end  model ajouter tarification */}

      {/* begin model modifier tarification and multiple tarifications */}
      <BasicModal
        widthSpecial={'40%'}
        open={openModifierTarification}
        onClose={handleCloseModifier}
        ChildrenContent={
          rowsSelected.length === 1 ? <><Box>
            <Typography variant='h4' sx={{
              fontSize: { lg: '40px', md: '30px', sm: '30px', xs: '20px' },
              mb: 2,
              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '20px'
            }}>
              Modifier Tarification ID :  {rowsSelected[0].id} </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center' }} >
              <Grid container spacing={1} sx={{
                display: 'flex',
                justifyContent: 'center',
                borderRadius: '12px',
                color: '#1D3E62',
                gap: '5px'
              }}>
                <Grid sx={{ display: 'flex', justifyContent: 'center' }} item xs={12} sm={12} md={12} lg={10} xl={10}>

                  <AutocompleteComboBox
                    required={true}
                    widthSpecific={'100%'}
                    Label={"Client"}
                    list={clients}
                    keyField={"ID_Client"}
                    valueField={"Nom"}
                    onChange={handleModifierSelectionChangeID_Client}
                    value={Number(modifierTarification.ID_Client)} // Ensure it's always a valid string
                    error={errors.error && !modifierTarification?.ID_Client}
                    helperText={
                      errors.error && !modifierTarification?.ID_Client ? "Client requis" : ""
                    }
                  />
                </Grid>



                <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                  <TextInputMui
                    required={true}
                    label="Départ"
                    type="text"
                    value={modifierTarification.depart}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, depart: e })}

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={5}>
                  <TextInputMui
                    required={true}
                    label="Destination"
                    type="text"
                    value={modifierTarification.destination}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, destination: e })}

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                  <TextInputMui

                    label="Taxi"
                    type="number"
                    value={modifierTarification.taxi}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, taxi: e })}

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                  <TextInputMui

                    label="T3.5"
                    type="number"
                    value={modifierTarification.T3_5}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, T3_5: e })}

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                  <TextInputMui

                    label="T7"
                    type="number"
                    value={modifierTarification.T7}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, T7: e })}

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                  <TextInputMui

                    label="T14"
                    type="number"
                    value={modifierTarification.T14}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, T14: e })}

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                  <TextInputMui

                    label="T18"
                    type="number"
                    value={modifierTarification.T18}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, T18: e })}

                  />
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={2} xl={2}>
                  <TextInputMui

                    label="Tracteur"
                    type="number"
                    value={modifierTarification.Tracteur}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, Tracteur: e })}

                  />
                </Grid>
                <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                  <TextInputMui
                    label="Semi_remorque"
                    type="number"
                    value={modifierTarification.semi_remorque}
                    setValue={(e) => setModifierTarification({ ...modifierTarification, semi_remorque: e })}

                  />
                </Grid>
                <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                  {errors.error === true ? (
                    <Typography variant='subtitle1' component="p" sx={{
                      color: 'red',
                      textAlign: 'center',

                    }}>  {errors.message} </Typography>
                  ) : null}
                </Grid>


                <Grid2 xs={12} sm={12} md={12} lg={12} xl={12} >
                  <Box sx={{
                    width: { xs: '150px', sm: '200px', md: '300px', lg: '400px', xl: '500px' },
                    display: 'flex', justifyContent: 'center', alignItems: 'center'
                  }}>
                    <ButtonAttribute
                      type="submit"
                      Label="Modifier Tarification"
                      color={'white'}
                      Bgcolor='#28A745'
                      height={'60px'}
                      width={'100%'}
                      action={handleOpenModifierOneTarification}
                    />
                  </Box>
                </Grid2>

              </Grid>
            </Box>

          </Box></> : <Typography variant='h4' sx={{
            fontSize: { lg: '20px', md: '20px', sm: '20px', xs: '20px' },
            mb: 2,
            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            fontWeight: '600',
            padding: '20px'
          }}>
            L'opération demandée est inexistante ou invalide.
            Pour garantir la sécurité des données, les modifications multiples ne sont pas autorisées. Veuillez contacter l'administrateur pour plus d'assistance </Typography>}
      />
      {/* end  model modifier tarification and multiple tarifications */}

      {/* Begin model Delete Tarification  and multiple tarifications */}
      <BasicModal
        open={openDeleteTarification}
        onClose={handleCloseDeleteTarification}
        ChildrenContent={
          rowsSelected.length === 1 ? <><Box>
            <Typography variant='h4' sx={{
              fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '10px'
            }}>
              Suppression de la tarification ID : {rowsSelected[0].id} </Typography>

            <Typography variant='h6' sx={{
              fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
              mb: 1,
              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',

              padding: '20px'
            }} >Voulez-vous vraiment supprimer cette tarification ?</Typography>
            <Box
              sx={{
                display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' },
                justifyContent: 'space-evenly', alignItems: 'center', gap: '20px'
              }} >

              <ButtonAttribute
                type="submit"
                Label="Annuler"
                color={'white'}
                Bgcolor='gray'
                height={'50px'}
                width={'100%'}
                action={handleCloseDeleteTarification}
              />
              <ButtonAttribute
                type="submit"
                Label="Supprimer"
                color={'white'}
                Bgcolor='#DC3545'
                height={'50px'}
                width={'100%'}
                action={handleOpenConfirmationPassword}
              />

            </Box>


          </Box></> :
            <><Box>
              <Typography variant='h4' sx={{
                fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
                fontFamily: 'Montserrat , sans-serif',
                color: '#1D3E62',
                textAlign: 'center',
                fontWeight: 'bold',
                padding: '10px'
              }}>
                Suppression des tarifications sélectionnées  </Typography>

              <Typography variant='h6' sx={{
                fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
                mb: 1,
                fontFamily: 'Montserrat , sans-serif',
                color: '#1D3E62',
                textAlign: 'center',
                padding: '20px'
              }} >Voulez-vous vraiment supprimer toutes les tarifications sélectionnées ?</Typography>

              {rowsSelected.length > 1 ? (
                <Box sx={{ display: 'flex', gap: '5px', width: '100%', overflowX: 'auto', marginBottom: '20px', justifyContent: 'center', alignItems: 'center' }}>
                  {rowsSelected.map((row, index) => (
                    <Box
                      key={index} // Use a unique key. Ideally, use a unique identifier from `row` if available.
                      sx={{
                        display: 'grid',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '20px',

                        padding: '10px',
                        width: '50px',
                        height: '40px',
                        borderRadius: '10%',
                        backgroundColor: '#DC3545',
                      }}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          color: '#fff',
                          fontSize: 14,
                          textAlign: 'center',
                          fontFamily: 'Montserrat, sans-serif',
                        }}
                      >
                        {row.id || 'N/A'} {/* Safeguard in case `id tarification` is undefined */}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : null}




              <Box
                sx={{
                  display: { xs: 'grid', sm: 'grid', md: 'grid', lg: 'flex', xl: 'flex' },
                  justifyContent: 'space-evenly', alignItems: 'center', gap: '20px'
                }} >

                <ButtonAttribute
                  type="submit"
                  Label="Annuler"
                  color={'white'}
                  Bgcolor='gray'
                  height={'50px'}
                  width={'100%'}
                  action={handleCloseDeleteTarification}
                />
                <ButtonAttribute
                  type="submit"
                  Label="Supprimer toutes"
                  color={'white'}
                  Bgcolor='#DC3545'
                  height={'50px'}
                  width={'100%'}
                  action={handleOpenConfirmationPassword}
                />

              </Box>


            </Box></>}
      />
      {/* end model Delete Tarification  and multiple tarifications */}

      {/* begin model export tarification */}
      <BasicModal
        open={openExtrationTarification}
        onClose={handleCloseExtrationTarification}
        ChildrenContent={<><Box>
          <Typography variant='h4' sx={{
            fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            fontWeight: 'bold',
            padding: '10px'
          }}>
            Extraction des données tarifaires </Typography>

          <Typography variant='h6' sx={{
            fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
            mb: 1,
            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            padding: '20px'
          }} >Vous disposez de deux types d'extraction des transactions. Si vous souhaitez extraire l'intégralité des données ou uniquement certains éléments, merci de les préciser dans le tableau.</Typography>

          <Box
            sx={{
              display: 'grid',
              alignItems: 'center', gap: '2px'
            }} >

            <ButtonAttribute
              type="button"
              Label="Extraire toutes les données ( XLSX )"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'70px'}
              width={'100%'}
              endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
              action={handleExtrationAllTarification}
            />
            <ButtonAttribute
              type="submit"
              Label="Extraire les données sélectionnées ( XLSX )"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'70px'}
              width={'100%'}
              action={handleExtrationSelectionsTarifications}
              endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
            />

          </Box>


        </Box></>}
      />
      {/* end  model export tarification */}

      {/* begin model importation tarification */}
      <BasicModal
        open={openImportationTarification}
        onClose={handleCloseImportationTarification}
        ChildrenContent={<><Box>
          <Typography variant='h4' sx={{
            fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },

            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            fontWeight: 'bold',
            padding: '10px'
          }}>
            Importation des données tarifaires </Typography>

          <Typography variant='h6' sx={{
            fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
            mb: 1,
            fontFamily: 'Montserrat , sans-serif',
            color: '#1D3E62',
            textAlign: 'center',
            padding: '20px'
          }} > Veuillez utiliser ce formulaire pour importer les tarifications depuis un fichier Excel </Typography>
          <ButtonAttribute
            type="button"
            Label="Télécharger le formulaire Excel"
            Bgcolor='#17A2B8'
            color='white'
            bgColorHover={'#117A8B'}
            height={'80px'}
            width={'100%'}
            endIcon={<FontAwesomeIcon icon={faDownload} color='white' />}
            action={handleDownload}
          />
          <Divider />
          <Box
            sx={{
              display: 'grid',
              justifyContent: 'space-evenly', alignItems: 'center',

            }} >
            <Typography variant='h6' sx={{
              fontSize: { lg: '20px', md: '16px', sm: '14px', xs: '14px' },
              mb: 1,
              fontFamily: 'Montserrat , sans-serif',
              color: '#1D3E62',
              textAlign: 'center',
              padding: '20px'
            }} > Cliquez sur le bouton ci-dessous pour sélectionner et importer votre fichier.</Typography>
            <ButtonAttribute
              type="button"
              Label="Importer toutes les données de tarifications"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'70px'}
              width={'100%'}
              endIcon={<FontAwesomeIcon icon={faCloudArrowUp} color='white' />}
              action={triggerFileInput}
            />
            <input
              id="file-upload"
              type="file"
              accept=".xlsx, .xls , .csv"
              style={{ display: 'none' }}
              onChange={handleFileImport}
            />
            <CustomizedProgressBars value={isLoading} color={isLoading === 100 ? 'success' : isLoading === 57 ? 'error' : 'gray'} />
          </Box>


        </Box></>}
      />

      {/* end model importation tarification */}

      {/* begin model confirmation password delete tarifications */}

      <BasicModal
        open={openConfirmationPassword}
        onClose={handleCloseConfirmationPassword}
        ChildrenContent={<><Box>
          <Typography variant='h4' sx={{
            fontSize: { lg: '35px', md: '30px', sm: '25px', xs: '20px' },
            fontFamily: 'Montserrat , sans-serif', color: '#1D3E62', textAlign: 'center',
            fontWeight: 'bold', padding: '20px', marginBottom: '20px'
          }}>
            Veuillez saisir votre mot de passe pour confirmer la suppression de la tarification
          </Typography>
          <Box sx={{ display: 'grid', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
            <TextInputMui
              type="password"
              label="Mot de passe"
              name="password"
              value={ConfrimedPassword.password}
              setValue={(e) => setConfirmedPassword({ ...ConfrimedPassword, password: e })}
              required
            />
            <ButtonAttribute
              type="submit"
              Label="Confirmer la suppression"
              Bgcolor='#17A2B8'
              color='white'
              bgColorHover={'#117A8B'}
              height={'50px'}
              width={'100%'}
              endIcon={<FontAwesomeIcon icon={faCheck} color='white' />}
              action={handleVerificationPassword}
            />

          </Box>
        </Box></>} />


      {/* alert for ajouter */}
      <AlertBar
        open={alertOpen}
        onClose={handleAlertClose}
        textContent="La tarification a été ajoutée avec succès."
        alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/* alert for ajouter */}

      {/* alert for modifier */}
      <AlertBar
        open={alertOpenSelectedModifier}
        onClose={handleAlertCloseSelectedModifier}
        textContent="Veuillez choisir une ligne"
        alertColor="warning"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/* not modifer line  row  */}
      <AlertBar
        open={alertOpenNotModiferRow}
        onClose={handleAlertCloseNotModiferRow}
        textContent={"Aucune des informations n'a été modifiée, donc je ne vais pas effectuer l'opération."}
        alertColor={"info"}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/*  alert for modifier success */}
      <AlertBar
        open={alertOpenUpdatedTarification}
        onClose={handleAlertCloseUpdatedTarification}
        textContent="Tarification mise à jour avec succès" alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/*  alert for modifier  */}

      {/* alert for delete tarification one row  */}
      <AlertBar
        open={alertOpenDeletedTarification}
        onClose={handleAlertCloseDeletedTarification}
        textContent="Tarification supprimée avec succès " alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      <AlertBar
        open={alertOpenPasswordNotValid}
        onClose={handleAlertClosePasswordNotValid}
        textContent="Mot de passe incorrect pour supprimer la tarification" alertColor="error"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      <AlertBar
        open={alertOpenMultiDeletedTarification}
        onClose={handleAlertMultiCloseDeletedTarification}
        textContent="Toutes les tarifications ont été supprimées avec succès." alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      {/* end alert for delete tarification one row  */}

      {/* alert for extration tarification   */}
      <AlertBar
        open={alertOpenNotSelectedLineExtration}
        onClose={handleAlertCloseNotSelectedLineExtration}
        textContent={"Veuillez préciser les lignes que vous souhaitez extraire pour télécharger le fichier au format .csv"}
        alertColor={"info"}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/* alert for importation tarification   */}
      <AlertBar
        open={alertOpenImport}
        onClose={handleCloseAlertImport}
        textContent="Importation effectuée avec succès ! Les données ont été ajoutées correctement"
        alertColor="success"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      />
      <AlertBar
        open={alertErrorImport}
        onClose={handleCloseErrorAlertImport}
        textContent="Importation non effectuée : le fichier contient des erreurs ou les valeurs sont incorrectes. Veuillez vérifier et réessayer."
        alertColor="error"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/* end alert for importation tarification   */}

      {/* begin alert confirmation password delete tarifications */}
      <AlertBar
        open={alertOpenConfirmDeleteTarification}
        onClose={handleCloseAlertConfirmDeleteTarification}
        textContent="le mot de passe est incorrect !"
        alertColor="error"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      {/* end alert confirmation password delete tarifications */}



    </ThemeProvider>
  );
};



